









































import { Component, Vue, Watch } from 'vue-property-decorator';
import List from '@/components/list.vue';
import Tab from '@/components/tab.vue'
import { goTop } from '../../global/utils';
import { getProjectInfo,getProject } from '@/api/project/project';
import storage from '@/global/storage'

@Component({
  components: {
    List,
    Tab
  },
})
export default class Task extends Vue {
  private projectTitle = ''
  private fromType =''
  private dataList: object[] = []
  private dataMap: object = {};
  private projectId = ''
  private loading: boolean = false;
  private total: number = 0;

  private owner: object = {}
  private name  = []

  private allData = []

  private filterOwner = 0;

  private scrollTop: number = 0;
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (from.name !== 'detail' && to.name === 'project') {
      this.init() // 重新加载数据
    }
  }
  private created() {
    console.log('$route', this.$route)
    this.init()
  }
  private activated() {
    document.documentElement.scrollTop = this.scrollTop
  }
  private deactivated() {
    this.scrollTop = document.documentElement.scrollTop
  }
  private async init() {
    let params  = this.$route.params.title ? this.$route.params : JSON.parse(storage.getSession('lm-project-params'))
    if(!params){
      params = {}
      params.id = this.$route.params.id
      if(typeof params.id != 'undefined'){
        let projectList:any= await getProject(params);
        this.$nextTick(() => {
          let currProject = projectList.rows.filter(item => params.id == item.projectId)[0]
          if(currProject){
            params.title = currProject.projectName
            params.type = 'all'
            this.initPage(params)
          }
        })
      }else{
        this.$Message.error("请输入有效地址")
      }
    }else{
      this.initPage(params)
    }
  }

  private initPage(params){
    this.dataList = [];
    this.dataMap ={}
    this.filterOwner = 0
    this.total = 0
    this.loading = true
    this.projectId = params.id
    this.projectTitle = params.title
    this.fromType = params.type =='my'?'我的项目':'全部项目'
    goTop()
    this.getProjectDetail(this.projectId)
  }

  private goProBack(){
    this.filterOwner = 0
    this.$router.go(-1) //返回上一页
  }

  private changeOwner(index) {
    this.filterOwner = index
    this.initData()
  }

  private openTrainFile(){
    let haveFile = false
    if(this.dataList && this.dataList.length > 0){
      if(this.dataMap[this.dataList[0]['id']] && this.dataMap[this.dataList[0]['id']].length > 0){
        if(this.dataMap[this.dataList[0]['id']][0].train_file){
          haveFile = true
          window.open(this.dataMap[this.dataList[0]['id']][0].train_file, "_blank");
        }
      }
    }
    if(!haveFile){
      this.$Notice.info({
        title: '提示',
        desc: '该项目未配置文档',
      });
    }
  }
  // 获取列表数据
  private async getProjectDetail(id) {
    goTop();
    this.loading = true;
    try {
      const data: any = await getProjectInfo(id);
      this.allData = data
      this.initData()
      this.$nextTick(() => {
        this.total = this.dataList.length;
      });
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
    let index = 0
    this.name = []
    this.name.push({value: index, label: '全部'})
    for (let key in this.owner) {
      index++
      this.name.push({value: index, label: this.owner[key], key: key})
    }

    console.log(this.name)
  }

  initData() {
    let data = this.allData
    this.dataList = [];
    this.owner = [];

    (data||[]).forEach(item => {
      this.owner[item.owner] = item.ownerName
      if(this.dataList.length == 0  || this.dataList.filter(item0 => item.module_id == (item0 as any).id).length ==0){
        if (this.filterOwner == 0 || this.name[this.filterOwner].key == item.owner) {
          this.dataList.push({id: item.module_id, title: item.module_title})
          this.dataMap[item.module_id] = data.filter(item1 => item1.module_id == item.module_id)
        }
      }
    })
  }
}
